import { PromotionType } from '@atlassian/mpac-api-client';
export const promotionTypeDescriptionMap = {
  [PromotionType.SHARED_PROMOTION]: 'All customers use the same promo link/code',
  [PromotionType.SINGLE_USE_PROMOTION]: 'Create a single-use promo link/code'
};
export const promotionTypeLabelMap = {
  [PromotionType.SHARED_PROMOTION]: 'Generic',
  [PromotionType.SINGLE_USE_PROMOTION]: 'Unique'
};